import * as components from './components'

export default [
  {
    path: '/catalog',
    component: components.Catalog,
    name: 'catalog'
  },
  {
    path: '/catalog/:docName/:docId',
    component: components.Catalog,
    name: 'catalog/document'
  },
  {
    path: '/catalog/:docName',
    component: components.Catalog,
    name: 'catalog/newDocument'
  }
]
